import moment from 'moment';
import * as Serializers from './serializers';
import { QueryParamConfig, DateRangeSchema } from './types';

export const StringParam: QueryParamConfig<string | null, string | null | undefined> = {
  encode: (v: string | null) => (v ? encodeURIComponent(v) : null),
  decode: (v: string | null | undefined) => (v ? decodeURIComponent(v) : v),
};
export const StringArrayParam: QueryParamConfig<string[] | null, string[] | null | undefined> = {
  encode: (v: string[] | null) => v?.map(StringParam.encode).join(','),
  decode: (v: string | null | undefined) =>
    v?.split(',').map((t) => {
      return StringParam.decode(t);
    }) as string[],
};
export const NullableStringArrayParam: QueryParamConfig<
  (string | null)[] | null,
  (string | null)[] | null | undefined
> = {
  encode: (v: (string | null)[] | null) =>
    v?.map((a) => StringParam.encode(a === null ? '__null__' : a)).join(','),
  decode: (v: string | null | undefined) =>
    v?.split(',').map((a) => {
      const decoded = StringParam.decode(a) as string;
      return decoded === '__null__' ? null : decoded;
    }),
};

export const NumberParam: QueryParamConfig<number | null, number | null | undefined> = {
  encode: (v: number | null) => v?.toString(),
  decode: (v: string | null | undefined) => (Number.isNaN(Number(v)) ? null : Number(v)),
};

export const BooleanParam: QueryParamConfig<boolean | null, boolean | null> = {
  encode: (v: boolean | null) => (v === null ? null : v.toString()),
  decode: (v: string | null | undefined) => (v ? v === 'true' : null),
};

export const DateParam: QueryParamConfig<moment.Moment | null, moment.Moment | null> = {
  encode: (v: moment.Moment | null) => v?.format('YYYY-MM-DD'),
  decode: (v: string | null | undefined) => (v ? moment(v, 'YYYY-MM-DD') : null),
};

export const DateTimeParam: QueryParamConfig<moment.Moment | null, moment.Moment | null> = {
  encode: (v: moment.Moment | null) => v?.format('YYYY-MM-DD HH:mm:ss'),
  decode: (v: string | null | undefined) => (v ? moment(v, 'YYYY-MM-DD HH:mm:ss') : null),
};

export const DateRangeParam: QueryParamConfig<DateRangeSchema | null, DateRangeSchema | null> = {
  encode: Serializers.encodeDateRange,
  decode: Serializers.decodeDateRange,
};
